import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import WishForm from 'components/WishForm';
import './addWish.css';

const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  fab: {
    position: 'fixed',
    bottom: '24px',
    right: '30px',
    boxShadow: 'none',
    zIndex: 2
  }
});

class AddWish extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleAdd = () => {
    const { wish, firebase, onSave } = this.props;
    const handleClose = this.handleClose;

    firebase.push('wishes', wish, function(error) {
      if (!error) {
        handleClose();
        onSave && onSave();
      }
    })
  }

  renderForm() {
    const { wish, fullScreen } = this.props;

    return (
      <Dialog
        open={ this.state.open }
        onClose={ this.handleClose }
        aria-labelledby="form-dialog-title"
        key="form"
        fullScreen={ fullScreen }
      >
        <DialogTitle id="form-dialog-title">Add Wish</DialogTitle>
        <DialogContent>
          <WishForm
            onChange={ this.props.onChange }
            onConfirm={ this.handleAdd }
            wish={ wish }
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={ this.handleAdd }>
            <AddIcon />
            Add
          </Button>
          <Button onClick={ this.handleClose } color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderButton() {
    const { classes } = this.props;

    return (
      <Fab
        className={ classes.fab }
        color="secondary"
        aria-label="Add"
        onClick={ this.handleClickOpen }
        key="button">
        <AddIcon />
      </Fab>
    );
  }

  render() {
    return [
      this.renderButton(),
      this.renderForm()
    ]
  }
}

export default withStyles(styles)(AddWish);



// WEBPACK FOOTER //
// ./src/components/AddWish/AddWish.js